import {Map} from 'immutable'
import PropTypes from 'prop-types'

import Button from '../../../../../shared_components/mui_base_components/button/Button'
import {TextGutterMedium} from '../../../components/blocks/Texts'

import './emptyElement.scss'

const EmptyElement = ({element, expandForm}) => (
  <aside className='empty-element'>
    <TextGutterMedium><strong>{element.get('display-name')}</strong></TextGutterMedium>
    <TextGutterMedium className='element-legend'>{element.get('legend')}</TextGutterMedium>
    <Button onClick={expandForm}>Start</Button>
  </aside>
)

EmptyElement.propTypes = {
  element: PropTypes.instanceOf(Map),
  expandForm: PropTypes.func
}

export default EmptyElement
